import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QuoteModal from '../../../components/feature/QuoteModal';

export default function CtaSection() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const { t } = useTranslation();

  const trustBadges = [
    { icon: 'ri-shield-check-line', key: 'cta_trust1' },
    { icon: 'ri-medal-line', key: 'cta_trust2' },
    { icon: 'ri-lock-line', key: 'cta_trust3' },
    { icon: 'ri-leaf-line', key: 'cta_trust4' },
  ];

  return (
    <>
      <section className="py-24 relative overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/44bd260364e59a1912888db2e79b572d.jpg"
          alt="Vecindario residencial limpio"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-blue-dark/90 to-brand-green-dark/80" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <span className="inline-block bg-white/10 border border-white/20 text-brand-green-light text-xs font-semibold px-4 py-1.5 rounded-full mb-6 tracking-wider uppercase">
            {t('cta_badge')}
          </span>
          <h2 className="font-heading font-bold text-white text-4xl md:text-5xl mb-6 leading-tight">
            {t('cta_heading')} <span className="text-brand-green">{t('cta_heading_accent')}</span> {t('cta_heading_end')}
          </h2>
          <p className="text-white/75 text-base max-w-xl mx-auto mb-10 leading-relaxed">
            {t('cta_desc')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => setQuoteOpen(true)}
              className="bg-brand-green hover:bg-brand-green-dark text-white font-semibold px-10 py-4 rounded-full flex items-center gap-3 transition-colors cursor-pointer whitespace-nowrap text-base"
            >
              <i className="ri-calculator-line text-lg" />
              {t('cta_btn')}
            </button>
            <a
              href="tel:+17542494067"
              className="bg-white/15 hover:bg-white/25 border border-white/30 text-white font-semibold px-8 py-4 rounded-full flex items-center gap-2 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              (754) 249-4067
            </a>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-14 pt-10 border-t border-white/15">
            {trustBadges.map((b) => (
              <div key={b.key} className="flex items-center gap-2 text-white/80">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${b.icon} text-brand-green-light text-lg`} />
                </div>
                <span className="text-sm">{t(b.key)}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      <QuoteModal isOpen={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </>
  );
}
